import React, { useState } from "react";
import { EdgeLabelRenderer, getStraightPath } from "@xyflow/react";
import EdgeHoverHandler from "../EdgeHoverHandler";
import EdgeButtonsContainer from "../EdgeButtonsContainer";

const ActionEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  target,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const hasTarget = Boolean(target);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <>
      <EdgeHoverHandler
        edgePath={edgePath}
        markerEnd={markerEnd}
        style={style}
        id={id}
        strokeWidth={20}
        isHovered={isHovered}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />

      <EdgeLabelRenderer>
        <EdgeButtonsContainer
          edgeId={id}
          target={target}
          labelX={labelX}
          labelY={labelY}
          isHovered={isHovered}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </EdgeLabelRenderer>
    </>
  );
};

export default ActionEdge;
